import { IListColumnMeta, EFieldType, IFormFieldsMeta } from 'shared/types/Page.interface';
import { EngineRequestDto, OrderResponseDto } from 'shared/api';

// Поля формы для создания/редактирования двигателя
export const ENGINE_FORM_FIELDS: IFormFieldsMeta = [
  {
    name: 'orderCode',
    label: 'Заказной код',
    type: EFieldType.input,
    required: true,
  },
  {
    name: 'serialNumber',
    label: 'Серийный номер',
    type: EFieldType.input,
    required: true,
  },
  {
    name: 'engineType',
    label: 'Тип машины',
    type: EFieldType.select,
    required: true,
    options: [
      { value: EngineRequestDto.engineType.ELECTRIC, label: 'Генератор' },
      { value: EngineRequestDto.engineType.HYBRID, label: 'Двигатель' },
    ],
  },
  {
    name: 'lastMaintenance',
    label: 'Дата последнего обслуживания',
    type: EFieldType.date,
  },
  {
    name: 'plannedDateOfStop',
    label: 'Планируемая дата останова',
    type: EFieldType.date,
  },
  {
    name: 'maintenanceIntervalHours',
    label: 'Межремонтный интервал (часы)',
    type: EFieldType.number,
    min: 1,
    placeholder: 'По умолчанию 10 000 ч',
  },
  {
    name: 'nameplatePhotoUuids',
    label: 'Снимок шильдика',
    type: EFieldType.file,
    accept: '.jpg,.jpeg,.png,.pdf',
    maxCount: 1,
    buttonText: 'Загрузить фото шильдика',
    buttonSize: 'small',
    fileType: 'nameplatePhoto',
  },
  {
    name: 'comment',
    label: 'Комментарий',
    type: EFieldType.textarea,
  },
] as const;

// Конфигурация колонок таблицы двигателей
export const ENGINE_TABLE_COLUMNS: IListColumnMeta = [
  {
    title: 'ID',
    type: EFieldType.input,
    dataIndex: 'id',
    fixed: 'left',
    sortingPriority: 1,
  },
  {
    title: 'ID пользователя',
    type: EFieldType.input,
    dataIndex: 'userId',
    sortingPriority: 2,
  },
  {
    title: 'Заказной код',
    type: EFieldType.input,
    dataIndex: 'orderCode',
    sortingPriority: 3,
  },
  {
    title: 'Серийный номер',
    type: EFieldType.input,
    dataIndex: 'serialNumber',
    sortingPriority: 4,
  },
  {
    title: 'Тип машины',
    type: EFieldType.select,
    dataIndex: 'engineType',
    options: {
      [EngineRequestDto.engineType.DIESEL]: 'Дизельный',
      [EngineRequestDto.engineType.GASOLINE]: 'Бензиновый',
      [EngineRequestDto.engineType.ELECTRIC]: 'Электрический',
      [EngineRequestDto.engineType.HYBRID]: 'Гибридный',
      [EngineRequestDto.engineType.TURBINE]: 'Турбинный',
      [EngineRequestDto.engineType.STEAM]: 'Паровой',
    },
    sortingPriority: 5,
  },
  {
    title: 'Последнее ТО',
    type: EFieldType.dateTime,
    dataIndex: 'lastMaintenance',
    sourceFormat: 'YYYY-MM-DD',
    targetFormat: 'DD.MM.YYYY',
    sortingPriority: 6,
  },
  {
    title: 'Следующее ТО',
    type: EFieldType.dateTime,
    dataIndex: 'nextMaintenance',
    sourceFormat: 'YYYY-MM-DD',
    targetFormat: 'DD.MM.YYYY',
    sortingPriority: 7,
  },
  {
    title: 'Планируемый останов',
    type: EFieldType.dateTime,
    dataIndex: 'plannedDateOfStop',
    sourceFormat: 'YYYY-MM-DD',
    targetFormat: 'DD.MM.YYYY',
    sortingPriority: 8,
  },
  {
    title: 'Комментарий',
    type: EFieldType.input,
    dataIndex: 'comment',
    sortingPriority: 9,
  },
];

// Конфигурация колонок таблицы заказов в модалке двигателя
export const ENGINE_ORDERS_TABLE_COLUMNS: IListColumnMeta = [
  {
    title: 'Тип работы',
    type: EFieldType.select,
    dataIndex: 'workType',
    options: {
      [OrderResponseDto.workType.MAINTENANCE]: 'Регламентное обслуживание',
      [OrderResponseDto.workType.REPAIR]: 'Внеплановое обслуживание',
      [OrderResponseDto.workType.UPGRADE]: 'Запрос ЗИП',
      [OrderResponseDto.workType.INSPECTION]: 'Помощь в подготовке ТЗ',
    },
    sortingPriority: 2,
  },
  {
    title: 'Статус',
    type: EFieldType.select,
    dataIndex: 'status',
    options: {
      [OrderResponseDto.status.CANCELLED]: 'Отменен',
      [OrderResponseDto.status.NEW]: 'Новый',
      [OrderResponseDto.status.IN_PROGRESS]: 'В работе',
      [OrderResponseDto.status.COMPLETED]: 'Завершен',
    },
    sortingPriority: 3,
  },
  {
    title: 'Дата создания',
    type: EFieldType.dateTime,
    dataIndex: 'createdAt',
    sourceFormat: 'YYYY-MM-DDTHH:mm:ss',
    targetFormat: 'DD.MM.YYYY HH:mm',
    sortingPriority: 4,
  },
  {
    title: 'Дата обновления',
    type: EFieldType.dateTime,
    dataIndex: 'updatedAt',
    sourceFormat: 'YYYY-MM-DDTHH:mm:ss',
    targetFormat: 'DD.MM.YYYY HH:mm',
    sortingPriority: 5,
  },
];

// Типы для статуса двигателя
export type EngineType = EngineRequestDto.engineType;
